import { CBL_APIS } from "@/api_framework/api_config";
import { ICBLListResponse, ICBLstatsBodyprops } from "@/api_framework/api_modals/CBL";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import { setCBLList } from "@/app_redux/reducers/slices/auth/patient_waiting_list_slice";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";

export const useCBLListAPI = () => {
  const configuration = useConfiguration();

  const dispatch = useAppDispatch();
  const execute = useCallback(
    async (filterParams: ICBLstatsBodyprops, key: string) => {
      dispatch(
        setLoading({
          key: "isPWLInProgress",
          status: true,
        }),
      );
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

        let API_FLAG = null;

        if (key === "all") {
          API_FLAG = `${CBL_APIS?.CBL_FILTER_API?.baseURL}`;
        } else if (key) {
          API_FLAG = `${CBL_APIS?.CBL_FILTER_CARD_API?.baseURL}${key}/`;
        } else {
          API_FLAG = `${CBL_APIS?.CBL_FILTER_API?.baseURL}`;
        }

        await axios
          .post(API_FLAG ?? "", filterParams, {
            headers: {
              Authorization: `${accessToken}`,
            },
          })
          .then((res: AxiosResponse<ICBLListResponse>) => {
            if (res.data.status === true) {
              dispatch(
                setCBLList({
                  data: res.data.data,
                }),
              );
              dispatch(
                setLoading({
                  key: "isPWLInProgress",
                  status: false,
                }),
              );
            } else {
              dispatch(
                setCBLList({
                  data: [],
                }),
              );
              dispatch(
                setLoading({
                  key: "isPWLInProgress",
                  status: false,
                }),
              );
            }
          })
          .catch((e: AxiosError) => {
            dispatch(
              setLoading({
                key: "isPWLInProgress",
                status: false,
              }),
            );
            dispatch(
              setCBLList({
                data: null,
              }),
            );
            if (e.response.status === 500) {
              toast.error("Server Error : Contact Tech Team.");
            }
          });
      } catch (e: any) {
        // toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return execute;
};
